import { getI18n } from 'react-i18next';
import countriesData from '../countries_en_ko.json';

interface CountryDataEnKo {
  iso2: string;
  name_en: string;
  name_ko: string;
  dial_code: string;
}

export interface CountryOption {
  value: string; // "KR", "US", or "Country Name (name_en)"
  label: string; // "국가명 (전화국번)" - 언어에 따라 name_ko 또는 name_en
  dialCode: string; // "+82", etc.
}

const typedCountriesData = countriesData as CountryDataEnKo[];

const isEnglish = (): boolean => {
  const i18n = getI18n();
  const lang = (i18n?.language || 'ko').toLowerCase();
  return lang.startsWith('en');
};

export const getCountryOptions = (): CountryOption[] => {
  const useEnglish = isEnglish();
  return typedCountriesData.map((c) => {
    let value = c.name_en;
    if (c.iso2 === 'KR' || c.iso2 === 'US') {
      value = c.iso2;
    }

    const displayName = useEnglish
      ? c.name_en
      : ((c.name_ko || '').trim() || c.name_en);
    const label = c.dial_code ? `${displayName} (${c.dial_code})` : displayName;

    return { value, label, dialCode: c.dial_code };
  });
};

export const getCountryLabel = (value: string): string => {
  if (!value) return '';
  const options = getCountryOptions();
  const found = options.find((opt) => opt.value === value);
  return found ? found.label : value;
};
